/* eslint-disable no-unused-vars */
export type LookupBookingUser = {
  lastName?: string;
  birthday?: string;
};

export type NameDetails = {
  first: string;
  last: string;
};

export type Phone = {
  code: string;
  number: string;
};

export type MatchingClient = {
  id?: string;
  clientId?: string;
  name?: NameDetails;
  email?: string;
  phone?: Phone;
  dob?: string;
  sex?: string;
  citizenship?: string;
};

export type MatchedReservationDetails = {
  packageCode?: string;
  packageType?: string;
  fromDate?: string;
  toDate?: string;
  isMNVV?: boolean;
};

export enum EligibilityStatus {
  BOOKING_NOT_FOUND = 'BOOKING_NOT_FOUND',
  CLAIMED = 'CLAIMED',
  EMAIL_MISMATCH = 'EMAIL_MISMATCH',
  SELF_SERVE_ARRAY = 'SELF_SERVE_ARRAY',
  CLAIMED_COMPLETED = 'CLAIMED_COMPLETED',
  READY_TO_CLAIM = 'READY_TO_CLAIM',
}

export type LookupBookingForClaimInput = {
  bookingNumber?: string;
  user?: LookupBookingUser;
  isManualEntry?: boolean;
};

export type LookupBookingForClaimResult = {
  bookingNumber?: string;
  status?: EligibilityStatus;
  sailors?: Array<MatchingClient>;
  reservationDetails?: MatchedReservationDetails;
  noOfGuests?: number;
};

export enum OTPType {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
}

export enum OTPStatus {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  TOO_MANY_ATTEMPTS = 'TOO_MANY_ATTEMPTS',
  CACHE_EXPIRED = 'CACHE_EXPIRED',
}

export type GenerateClaimBookingOTPInput = {
  matchingClientId?: string;
  otpType?: OTPType;
};

export type GenerateClaimBookingOTPResult = {
  status?: OTPStatus;
  message?: string;
};

export enum ClaimBookingOTPStatus {
  SUCCESSFULLY_CLAIMED = 'SUCCESSFULLY_CLAIMED',
  ERROR = 'ERROR',
  INVALID_OTP = 'INVALID_OTP',
  BOOKING_NOT_FOUND = 'BOOKING_NOT_FOUND',
  TOO_MANY_ATTEMPTS = 'TOO_MANY_ATTEMPTS',
  CACHE_EXPIRED = 'CACHE_EXPIRED',
}

export type ClaimBookingRequest = {
  otp?: string;
  otpType?: OTPType;
  matchingClientId?: string;
};

export type ClaimBookingResponse = {
  status?: ClaimBookingOTPStatus;
  message?: string;
  sailors?: MatchingClient[];
  reservationDetails?: MatchedReservationDetails;
  bookingNumber?: string;
  noOfGuests?: number;
};

export type OtpVerificationResult = {
  status?: ClaimBookingOTPStatus;
  message?: string;
} | null;

export type PostClaimSailorProfileUpdateInput = {
  matchingClientId?: string;
  updateProfileEmail?: boolean;
  selectedDOB?: string;
};

export type PostClaimSailorProfileUpdateResult = {
  success?: boolean;
  message?: string;
  clientId?: string;
  status?: string;
};
